





























import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountLendingRepaymentPlansSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/RepaymentPlans/AccountLendingRepaymentPlansSettings';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountLendingRepaymentPlansSettingsRead' })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountLendingRepaymentPlansSettings;

}
